import React from 'react'
import GlassEffect from '../GlassEffect/GlassEffect'
import LandingVideo from '../LandingVideo/LandingVideo'


export default function HeroImageCard({ img, icon, video, aspectRatio }) {
    const children = <img src={`${process.env.REACT_APP_BASENAME}/img/${icon}`} alt="" />
    return (
        <div className="landing-hero-images-card">
            <div className="landing-hero-images-card__img">
                {video ? <LandingVideo
                    aspectRatio={aspectRatio}
                    imgSrc={`${process.env.REACT_APP_BASENAME}/img/${img}`}
                    videoSrc={`${process.env.REACT_APP_BASENAME}/video/${video}`}
                /> :
                    <img src={`${process.env.REACT_APP_BASENAME}/img/${img}`} alt="" />}
            </div>
            <GlassEffect children={children} className='landing-hero-images-card__glass' />
        </div>
    )
}
